<template>
<div>
<Apptab />
<v-container>
    <h1>participants</h1>
  <v-data-table
    :headers="getHeaders()"
    :items="participants"
    :items-per-page="10"
    no-data-text="Ingen data tillgänglig"
    :footer-props="{
    'items-per-page-text': 'Rader per sida:',
    'items-per-page-all-text': 'Allt',
    }"
    class="elevation-1"
  >
    <template v-slot:item.email="{ item }">
      {{ item.email === 'null'?'':item.email }}
    </template>
    <template v-slot:item.phone="{ item }">
      {{ item.phone === 'null'?'':item.phone }}
    </template>
  <!-- <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>{{ item.status === 'yes'?'öppna':'stängd' }}</v-chip>
    </template>
    <template v-slot:item.reply_deadline_date="{ item }">
      {{ item.reply_deadline === 'yes'?toDDMMYY(item.reply_deadline_date):'Ingen tidsfrist' }}
    </template> -->
    <template v-slot:footer.page-text="items">
       {{ items.pageStart }} - {{ items.pageStop }} av {{ items.itemsLength }} 
       </template>
  </v-data-table>
  </v-container>
  </div>
</template>


<script>
import Apptab from "./apptab";
import store from "../../../store";
import axios from "axios";
  export default {
  components: {
    Apptab,
  },
    data () {
      return {
        store: store,
        id: this.$route.params.id,
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'name',
            // v-if:participants.contact_info3 !== null,
          },
          { text: 'Email', value: 'email' },
          { text: 'Phone', value: 'phone' },
          this.p
        ],
        participants: [],
        p: '',
      }
    },
    created: async function() {
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}participants/${this.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.participants = resp.data.participants;
        this.p = `text:${this.participants[0].contact_info1}, value:"ci0"`
        console.log(this.headers)
    },
    methods: {
      getColor (status) {
        if (status === 'yes') return 'green'
        else return 'red'
      },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        getHeaders(){
          let info1 = this.participants[0].contact_info1=== null?'':this.participants[0].contact_info1
          let info2 = this.participants[0].contact_info2=== null?'':this.participants[0].contact_info2
          let info3 = this.participants[0].contact_info3=== null?'':this.participants[0].contact_info3
          let info4 = this.participants[0].contact_info4=== null?'':this.participants[0].contact_info4
          let info5 = this.participants[0].contact_info5=== null?'':this.participants[0].contact_info5
        let head = [
        {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'name',
            // v-if:participants.contact_info3 !== null,
          },
          { text: 'Email', value: 'email' },
          { text: 'Phone', value: 'phone' },
          {text: `${info1}`, value:"ci0"},
          {text: `${info2}`, value:"ci1"},
          {text: `${info3}`, value:"ci2"},
          {text: `${info4}`, value:"ci3"},
          {text: `${info5}`, value:"ci4"}
      ];
      // console.log(aa)
      return head
    }
    },
  }
</script>